import { useTranslation } from 'react-i18next';
import SaveButton from '@pages/partners-order/footer/SaveButton';



interface FooterProps {
	scrollToTop: () => void
}


const Footer = (props: FooterProps) => {
	const { scrollToTop } = props;
	const { t } = useTranslation('forms');
	
	return (
		<div className='footer-section'>

			<p className='gdpr-message'>{t('footer.partnersGdprMessage')}</p>
			
			<div className='send-button'>
				<SaveButton scrollToTop={scrollToTop} />
			</div>
			
		</div>
	);
};

export default Footer;